import Channel from './Channel/Channel';
import SimpleChannel from './Channel/SimpleChannel';
import RouteEvent from './Channel/payload/RouteEvent';
import BookingEvent from './Channel/payload/BookingEvent';
import ItemListEvent from './Channel/payload/ItemListEvent';
import ItemDetailEvent from './Channel/payload/ItemDetailEvent';
import AuthState from '../Services/Auth/Models/AuthState';
import CartEvent from './Channel/payload/CartEvent';
import ItemDetailListEvent from './Channel/payload/ItemDetailListEvent';
import SearchDetailEvent from './Channel/payload/SearchDetailEvent';
import RouteBookingEvent from './Channel/payload/RouteBookingEvent';
import ErrorEvent from './Channel/payload/ErrorEvent';
import LinkTrackingEvent from './Channel/payload/LinkTrackingEvent';
import TravelDetailsEvent from './Channel/payload/TravelDetailsEvent';
import AdditionalServicesEvent from './Channel/payload/AdditionalServicesEvent';

// BOOKING RELATED

export const bookingInitEvent = new Channel<BookingEvent>(BookingEvent, 'booking-init');
export const bookingItemAddedEvent = new Channel<BookingEvent>(BookingEvent, 'booking-item-added');
export const bookingItemRemovedEvent = new Channel<BookingEvent>(
  BookingEvent,
  'booking-item-removed'
);
export const bookingHotelUpgradeEvent = new Channel<BookingEvent>(
  BookingEvent,
  'booking-hotel-upgrade'
);
export const checkoutStartedEvent = new Channel<BookingEvent>(BookingEvent, 'checkout-started');
export const checkoutStepEvent = new Channel<BookingEvent>(BookingEvent, 'checkout-step');
export const checkoutFinishedEvent = new Channel<BookingEvent>(BookingEvent, 'checkout-finished');
export const cartViewedEvent = new Channel<BookingEvent>(BookingEvent, 'cart-viewed');
export const errorEvent = new Channel<ErrorEvent>(ErrorEvent, 'error');
export const addTravelDetailsEvent = new Channel<TravelDetailsEvent>(
  TravelDetailsEvent,
  'travel-details-added'
);
export const addAdditionalServicesEvent = new Channel<AdditionalServicesEvent>(
  AdditionalServicesEvent,
  'additional-services-added'
);

// Products
export const itemListEvent = new Channel<ItemListEvent>(ItemListEvent, 'item-list');
export const itemExactListEvent = new Channel<ItemListEvent>(ItemListEvent, 'item-exact-list');
export const itemDetailEvent = new Channel<ItemDetailEvent>(ItemDetailEvent, 'item-detail');
export const itemDetailListEvent = new Channel<ItemDetailListEvent>(
  ItemDetailListEvent,
  'item-detail-list'
);
export const searchDetailEvent = new Channel<SearchDetailEvent>(SearchDetailEvent, 'search-detail');
export const itemSelectEvent = new Channel<ItemDetailEvent>(ItemDetailEvent, 'item-select');

// AUTH

export const loginEvent = new Channel<AuthState>(AuthState, 'login');
export const logoutEvent = new SimpleChannel('logout');

// PAGEVIEW

export const routeChangeEvent = new Channel<RouteEvent>(RouteEvent, 'route-change');
export const routeBookingEvent = new Channel<RouteBookingEvent>(RouteBookingEvent, 'route-booking');

//CART
export const cartRemoveItemEvent = new Channel<CartEvent>(CartEvent, 'cart-remove-item');
export const cartEditItemEvent = new Channel<CartEvent>(CartEvent, 'cart-edit-item');

// CONTIBE-161 - New Event Channels for LinkTracking
export const compareAddEvent = new Channel<LinkTrackingEvent>(LinkTrackingEvent, 'compare-add');
export const compareOpenEvent = new Channel<LinkTrackingEvent>(LinkTrackingEvent, 'compare-open');
export const compareBookEvent = new Channel<LinkTrackingEvent>(LinkTrackingEvent, 'compare-book');

export const listPackageDetailEvent = new Channel<LinkTrackingEvent>(
  LinkTrackingEvent,
  'list-package-details'
);
export const detailsOpenEvent = new Channel<LinkTrackingEvent>(LinkTrackingEvent, 'details-open');
export const detailsAttributesEvent = new Channel<LinkTrackingEvent>(
  LinkTrackingEvent,
  'details-attributes'
);
export const detailsImagesEvent = new Channel<LinkTrackingEvent>(
  LinkTrackingEvent,
  'details-images'
);
export const detailsSupplierEvent = new Channel<LinkTrackingEvent>(
  LinkTrackingEvent,
  'details-supplier'
);
export const detailsConditionsEvent = new Channel<LinkTrackingEvent>(
  LinkTrackingEvent,
  'details-conditions'
);
